/**
 * A personal custom MCP server's own page, under Plugins. `connections_`
 * (trailing underscore) keeps it a sibling of the catalogue; `mcp/` keeps
 * server ids apart from plugin ids. Organization servers keep their page
 * under Compliance → Integrations.
 *
 * @module routes/$org.connections_.mcp.$serverId
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { CustomMcpServerPage } from "../components/apps/integrations/CustomMcpServerPage";
import { useRegulationOrg } from "../components/regulation/useRegulationOrg";

function PersonalCustomMcpServerRoute() {
  const { org: orgSegment, serverId } = Route.useParams();
  const { org } = useRegulationOrg();
  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col bg-background">
      <CustomMcpServerPage
        key={`${org?.id ?? ""}:${serverId}`}
        organizationId={org?.id ?? null}
        orgSegment={orgSegment}
        serverId={serverId}
        section="plugins"
      />
    </div>
  );
}

export const Route = createFileRoute("/$org/connections_/mcp/$serverId")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: PersonalCustomMcpServerRoute,
});
